import React from "react";
import { notification, Table } from "antd";
import "./sales_data_customer.css";
import { CustomerData, useCustomerTable } from "../../components/hoc_sales_data_customer";

interface SalesDataCustomerProps {
    onSelect?: (customer: CustomerData) => void;
}
const SalesDataCustomer: React.FC<SalesDataCustomerProps> = ({ onSelect }) => {
    const { data, columns, components, loading, error } = useCustomerTable(onSelect);
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    return (
        <div id="iau9" style={transformStyle}>
            <div className="gjs-grid-row" id="iorhn">
                <div className="gjs-grid-column" id="ivzue">
                </div>
            </div>
            <div className="gjs-grid-row" id="is512">
                <div className="gjs-grid-column" id="i8fwh">
                    <Table
                        bordered
                        style={{ tableLayout: 'fixed', maxWidth: '100%' }} 
                        columns={columns}
                        components={components}
                        dataSource={data}
                        loading={loading}
                        scroll={{ x: 1050, y: 'auto' }}
                        onRow={(record) => ({
                            onClick: () => {
                                if (record.record_status !== '2' && onSelect) {
                                    onSelect(record);
                                } else if (record.record_status === '2') {
                                    notification.warning({ message: 'Warning', description: 'Data telah di nonaktifkan silahkan hubungi Admin!' });
                                }
                            },
                        })}
                    />
                    {error && <div style={{ color: 'red' }}>{error}</div>}
                </div>
            </div>
        </div>
    );
};

export default SalesDataCustomer;
